/* RESPONSIBLE TEAM: team-workflows */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { CX_SCORE_RATING_RECEIVED_TARGET } from 'embercom/lib/operator/custom-bots/constants';

export default class WorkflowBackgroundOnlyCheck extends BaseValidator {
  @service declare intl: IntlService;

  validate(_value: unknown, _options: ValidationOptions, model: $TSFixMe) {
    if (model.group?.workflow?.workflowInstanceTrigger !== CX_SCORE_RATING_RECEIVED_TARGET) {
      return true;
    }

    let editorConfig = model.editorConfig;

    if (!editorConfig) {
      return true;
    }

    if (!editorConfig.isBackgroundOnly) {
      return true;
    }

    if (model.isCustomerFacing) {
      return this.intl.t(
        'operator.workflows.visual-builder.validations.workflow-is-background-only',
      );
    }

    return true;
  }

  static getDependentsFor() {
    return ['model.editorConfig', 'model.editorConfig.isBackgroundOnly', 'model.isCustomerFacing'];
  }
}
